import React, { useRef, useState, useLayoutEffect } from "react";

const AutoScaler = ({ children, mode }) => {
  const containerRef = useRef(null);
  const childRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const child = childRef.current;
    if (!container || !child) return;

    let rafId = null;

    const measure = () => {
      const containerW = container.offsetWidth;
      const containerH = container.offsetHeight;
      const childW = child.scrollWidth;
      const childH = child.scrollHeight;

      if (!containerW || !containerH || !childW || !childH) return;

      const scaleX = containerW / childW;
      const scaleY = containerH / childH;
      const newScale = mode === 'width' ? scaleX : Math.min(scaleX, scaleY);
      setScale(prev => (Math.abs(prev - newScale) > 0.001 ? newScale : prev));
    };

    const scheduleRecalculate = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(measure);
    };

    // מדידה ראשונית סינכרונית + fallback ב-RAF לתפוס גודל אחרי ש-Dashboard
    // הגדיר את ה-scale שלו (ב-WV91 ResizeObserver לא תמיד מופעל על שינויי parent)
    measure();
    scheduleRecalculate();

    // צופה בקונטיינר — כשהמסך משנה גודל
    const containerObs = new ResizeObserver(scheduleRecalculate);
    containerObs.observe(container);

    // צופה בילד — כשתוכן נטען אסינכרונית (DOM nodes חדשים)
    // MutationObserver לא יוצר לולאת feedback כי הוא לא מגיב לשינויי גודל
    const mutationObs = new MutationObserver(scheduleRecalculate);
    mutationObs.observe(child, { childList: true, subtree: true });

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      containerObs.disconnect();
      mutationObs.disconnect();
    };
  }, [mode]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%", height: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflow: "hidden"
      }}
    >
      <div
        ref={childRef}
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "center top",
          flexShrink: 0
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AutoScaler;
